import { getEnvVar } from '../../envUtils.ts';
import ApiService from '../../service/ApiService.js';
import * as ucpActions from '../../store/UnifiedControlPlaneSlice.js';

const ORDERS_URL = 'oms/orders';

const getOrders = () => async (dispatch) => {
  dispatch(ucpActions.getOrdersRequest());
  try {
    const response = await ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}${ORDERS_URL}`);
    dispatch(ucpActions.getOrdersSuccess(response.data));
  } catch (error) {
    dispatch(ucpActions.getOrdersFailure(error.message));
    console.error('Error while getting orders:', error);
  }
};

const createOrders = (body, callback) => async (dispatch) => {
  dispatch(ucpActions.createOrderRequest);
  try {
    const response = await ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}${ORDERS_URL}`, body);
    dispatch(ucpActions.createOrderSuccess(response.data));
    if (callback) {
      callback();
    }
  } catch (error) {
    dispatch(ucpActions.createOrderFailure());
    console.error('Error while creating order:', error);
  }
};

const updateSingleOrder = (orderId, action, callback) => async (dispatch) => {
  const body = {
    action,
  }
  dispatch(ucpActions.updateOrderRequest());
  try {
    const response = await ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}${ORDERS_URL}/${orderId}/action`, body);
    dispatch(ucpActions.updateOrderSuccess(response));
    if (callback) {
      callback();
    }
  } catch (error) {
    dispatch(ucpActions.updateOrderFailure());
    console.error('Error while updating order:', error);
  }
};

const updateSchedules = (missionID, action, schedule, callback) => async (dispatch) => {
  const body = {
    action
  }
  dispatch(ucpActions.updateScheduleRequest());
  try {
    await ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionID}/schedules/${schedule?.scheduleId}/action`, body);
    dispatch(ucpActions.updateScheduleSuccess({ action, schedule }));
    if (callback) {
      callback(action);
    }
  } catch (error) {
    const errorMessage = error?.response?.data;
    if (errorMessage) {
      dispatch(ucpActions.updateScheduleFailure({ action, error: errorMessage }));
    } else {
      dispatch(ucpActions.updateScheduleFailure({ action }));
    }
  }
};

const deleteOrders = (orderId, orderName, callback) => async (dispatch) => {
  dispatch(ucpActions.deleteOrderRequest());
  try {
    await ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}${ORDERS_URL}/${orderId}`);
    dispatch(ucpActions.deleteOrderSuccess(orderName));
    if (callback) {
      callback();
    }
  } catch (error) {
    dispatch(ucpActions.deleteOrderFailure());
    console.error('Error while deleting orders:', error);
  }
};

const getOrderAssignments = (missionID, scheduleID, callback) => async (dispatch) => {
  dispatch(ucpActions.getOrderAssignmentsRequest());
  try {
    const response = await ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionID}/schedules/${scheduleID}/assignments`);
    dispatch(ucpActions.getOrderAssignmentsSuccess(response.data));
    if (callback) {
      callback();
    }
  } catch (error) {
    dispatch(ucpActions.getOrderAssignmentsFailure());
    console.error('Error while getting order assignments:', error);
  }
};

const getOrderAssignmentsForSingleOrder = (missionID, orderId) => async (dispatch) => {
  dispatch(ucpActions.getOrderAssignmentsForSingleOrderRequest());
  try {
    const response = await ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionID}/orders/${orderId}/assignments`);
    dispatch(ucpActions.getOrderAssignmentsForSingleOrderSuccess(response.data));
  } catch (error) {
    dispatch(ucpActions.getOrderAssignmentsForSingleOrderFailure());
    console.error('Error while getting order assignments:', error);
  }
}

const generateSchedule = (scenarioID, missionID, body, callback) => async (dispatch) => {
  dispatch(ucpActions.genrateScheduleRequest());
  try {
    const response = await ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/mission/${missionID}/schedules/generate?scenarioID=${scenarioID}`, body);
    dispatch(ucpActions.genrateScheduleSuccess(response?.data));
    if (callback) {
      callback();
    }
  } catch (error) {
    dispatch(ucpActions.genrateScheduleFailure());
    console.error('Error while generating schedule:', error);
  }
};

const getSchedule = (missionID, scheduleID, callback) => async (dispatch) => {
  dispatch(ucpActions.getScheduleRequest())
  try {
    const response = await ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionID}/schedules/${scheduleID}`);
    dispatch(ucpActions.getScheduleSuccess(response.data));
    if (callback) {
      callback();
    };
  } catch (error) {
    dispatch(ucpActions.getScheduleFailure());
    console.error(error);
  }
};

const getCurrentSchedule = (missionID, callback) => async (dispatch) => {
  dispatch(ucpActions.getCurrentScheduleRequest())
  try {
    const response = await ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionID}/schedules/current`);
    dispatch(ucpActions.getCurrentScheduleSuccess(response.data));
    if (callback) {
      callback(response?.data);
    };
  } catch (error) {
    dispatch(ucpActions.getCurrentScheduleFailure());
    console.error(error);
  }
};

const getAllSchedules = (missionID, callback) => async (dispatch) => {
  dispatch(ucpActions.getAllScheduleRequest())
  try {
    const response = await ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionID}/schedules`);
    dispatch(ucpActions.getAllScheduleSuccess(response.data));
    if (callback) {
      callback();
    };
  } catch (error) {
    dispatch(ucpActions.getAllScheduleFailure());
    console.error(error);
  }
};

const deleteScheduleById = (missionID, action, schedule, callback) => async (dispatch) => {
  dispatch(ucpActions.deleteScheduleRequest());
  try {
    await ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionID}/schedules/${schedule?.scheduleId}`);
    dispatch(ucpActions.deleteScheduleSuccess({ action, schedule }));
    if (callback) {
      callback();
    }
  } catch (error) {
    dispatch(ucpActions.deleteScheduleFailure({ action }));
    console.error('Error while deleting schedule:', error);
  }
};

const getGroupFromMultiSat = (missionId, scenarioid, propagationType) => async (dispatch) => {
  dispatch(ucpActions.getGroupRequest())
  try {
    const response = await ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioid}/orbit?propagation=${propagationType}`);
    dispatch(ucpActions.getGroupSuccess(response?.data));
    // consider the clock time of latest satellite and satelliteGroup
    const satellites = Array.isArray(response?.data.satellites) && response?.data.satellites.length > 0 ? response?.data?.satellites : [];
    const satelliteGroups = satellites.length > 0 ? satellites[satellites.length - 1]?.satelliteGroups : [];
    const setLatestClockTime = satelliteGroups.length > 0 ? satelliteGroups?.[satelliteGroups.length - 1]?.visualizationData?.documentMetadata?.clock?.currentTime : '';
    if (setLatestClockTime) { dispatch(ucpActions.setScenarioCurrentTime(setLatestClockTime)); } //set the current scenario time
    dispatch(ucpActions.setSimulationClockFlag(true));
  } catch (error) {
    dispatch(ucpActions.getGroupFailure())
    console.error(error)
  }
}

const getGroundStationsFromMission = (missionId) => async (dispatch) => {
  dispatch(ucpActions.getGroundStationRequest())
  try {
    const response = await ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}groundstation/groundStationDetails/${missionId}`);
    dispatch(ucpActions.getGroundStationSuccess(response.data))
  } catch (error) {
    dispatch(ucpActions.getGroundStationFailure())
    console.error(error)
  }
}

const postPredictionData = (missionId, scenarioId, satelliteGroupId, satelliteId, scheduleId, fidelity = 'low') => async (dispatch) => {
  dispatch(ucpActions.postPredictionDataRequest())
  try {
    const response = await ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionId}/prediction?satelliteGroupID=${satelliteGroupId}&satelliteID=${satelliteId}&scheduleID=${scheduleId}&fidelity=${fidelity}`);
    dispatch(ucpActions.postPredictionDataSuccess(response))
  } catch (error) {
    dispatch(ucpActions.postPredictionDataFailure(error.message));
    console.error(error)
  }
}
const getPredictionData = (missionId, scenarioId, scheduleId, satelliteId, satelliteGroupId) => async (dispatch) => {
  dispatch(ucpActions.getPredictionDataRequest())
  try {
    const response = await ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionId}/prediction?satelliteGroupID=${satelliteGroupId}&satelliteID=${satelliteId}&scheduleID=${scheduleId}`);
    dispatch(ucpActions.getPredictionDataSuccess(response.data))
  } catch (error) {
    dispatch(ucpActions.getPredictionDataFailure(error.message));
    console.error(error)
  }
}

const getCurrentUcpConfig = (missionId) => async (dispatch) => {
  dispatch(ucpActions.getCurrentUcpConfigRequest())
  try {
    const response = await ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionId}/ucp/config/current`);
    dispatch(ucpActions.getCurrentUcpConfigSuccess(response.data))
  } catch (error) {
    dispatch(ucpActions.getCurrentUcpConfigError())
    console.error(error)
  }
}

const setCurrentUcpConfig = (missionId, scenarioId, scenarioName, callback) => async (dispatch) => {
  dispatch(ucpActions.setCurrentUcpConfigRequest())
  try {
    const response = await ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionId}/ucp/config`, {
      mode: "Simulation",
      scenarioId: scenarioId
    })
    dispatch(ucpActions.setCurrentUcpConfigSuccess({ response: response.data, scenarioName }))
    if (callback) {
      callback();
    }
  } catch (error) {
    dispatch(ucpActions.setCurrentUcpConfigError())
  }
}

const disconnectScenario = (missionID, scenarioName, callback) => async (dispatch) => {
  dispatch(ucpActions.disconnectScenarioRequest())
  try {
    const response = await ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}oms/${missionID}/ucp/config/disconnect`, {})
    dispatch(ucpActions.disconnectScenarioSuccess({ response: response.data, scenarioName }))
    if (callback) {
      callback()
    }
  } catch (error) {
    dispatch(ucpActions.disconnectScenarioFailure())
  }
}

const UnifiedControlPlaneService = {
  getOrders,
  createOrders,
  updateSingleOrder,
  updateSchedules,
  deleteOrders,
  getOrderAssignments,
  getOrderAssignmentsForSingleOrder,
  generateSchedule,
  getSchedule,
  getCurrentSchedule,
  getAllSchedules,
  deleteScheduleById,
  getGroupFromMultiSat,
  getGroundStationsFromMission,
  postPredictionData,
  getPredictionData,
  getCurrentUcpConfig,
  setCurrentUcpConfig,
  disconnectScenario
};

export default UnifiedControlPlaneService;
